import { ActionIcon, Tooltip } from '@mantine/core';
import { IconSettings, IconUserCog } from '@tabler/icons-react';
import { type ContextMenuItemOptions, useContextMenu } from 'mantine-contextmenu';
import * as React from 'react';
import { TOOLTIPS } from '../../../resource/tooltipTexts';
import { useMyNavigate } from '../../router/createdRouter';
import { useUserId } from '../../authentication/useUserId';
import { useUserActions } from '../../../resource/resources/persistables/user/userResource';

export const ProjectSettingsButton= ({ projectId }: {
    projectId: string | undefined;
}) => {
    const navigate = useMyNavigate();
    const { showContextMenu } = useContextMenu();
    const userId = useUserId('');

    const userActions = useUserActions()
    const userProjectRights = userActions.useGetUserEffectiveRightsOfUser(userId, projectId);

    const contextMenuItems = (): Array<ContextMenuItemOptions> => {
        const menuItems: Array<ContextMenuItemOptions> = [
            {
                key: 'project_settings',
                title: 'Project Settings',
                disabled: true,
                icon: <IconSettings color={'var(--mantine-color-base-button)'} />,
                onClick: () => undefined,
            },
        ];

        if (userProjectRights.data?.isManager) {
            menuItems.push({
                key: 'project_user_management',
                title: 'Project User Management',
                icon: <IconUserCog color={'var(--mantine-color-base-button)'} />,
                onClick: () => {
                    if (projectId) {
                        navigate({
                            route: '/project-user-management/:id',
                            routeParams: { id: projectId },
                        });
                    }
                },
            });
        }

        return menuItems;
    };

    return (
        <Tooltip label={TOOLTIPS.PROJECT_SETTINGS}>
            <ActionIcon
                size={'sm'}
                variant={'transparent'}
                onClick={(event) => showContextMenu(contextMenuItems())(event)}
            >
                <IconSettings color={'var(--mantine-color-base-button)'} />
            </ActionIcon>
        </Tooltip>
    );
};
